import { ADD_ORGANISATION } from './constants';

export function addOrganisation(name, callback) {
  return {
    type: ADD_ORGANISATION,
    name,
    callback,
  };
}
